module.exports = __webpack_public_path__ + "img/theme.97e2c39a.svg";